<script lang="ts">
/** Fills flex remaining space */
export default {
  name: "PlSpacer",
};
</script>

<script lang="ts" setup>
//
</script>

<template>
  <div class="pl-layout-component" style="flex-grow: 1" />
</template>
